export default "__VITE_ASSET__DyY7P$gQ__"